import { createAction, props } from '@ngrx/store';

import { IContact } from '@ruby/modules/account/models/contact.interface';
import {
  IThirdPartyLOA,
  IThirdPartyLOAStatus,
  IThirdPartyTemplate,
  IThirdPartyUpdateStatus
} from '@ruby/modules/third-party/models/third-party.interface';
import { IError } from '@ruby/shared/models/request/error.interface';

export const loadLOA = createAction(
  '[Third Party Core] Load LOA'
);

export const loadLOASuccess = createAction(
  '[Third Party Core] Load LOA Success',
  props<{ data: Array<IThirdPartyLOA> }>()
);

export const loadLOAFailure = createAction(
  '[Third Party Core] Load LOA Failure',
  props<{ error: IError }>()
);

export const loadContract = createAction(
  '[Third Party Core] Load Contract',
  props<{ data: string }>()
);

export const loadContractSuccess = createAction(
  '[Third Party Core] Load Contract Success',
  props<{ data: IThirdPartyLOA }>()
);

export const loadContractFailure = createAction(
  '[Third Party Core] Load Contract Failure',
  props<{ error: IError }>()
);

export const loadLOAStatus = createAction(
  '[Third Party Core] Load LOA Status'
);

export const loadLOAStatusSuccess = createAction(
  '[Third Party Core] Load LOA Status Success',
  props<{ data: IThirdPartyLOAStatus }>()
);

export const loadLOAStatusFailure = createAction(
  '[Third Party Core] Load LOA Status Failure',
  props<{ error: IError }>()
);

export const loadContactDetails = createAction(
  '[Third Party Core] Load Contact Details',
  props<{ data: string }>()
);

export const loadContactDetailsSuccess = createAction(
  '[Third Party Core] Load Contact Details Success',
  props<{ data: IContact }>()
);

export const loadContactDetailsFailure = createAction(
  '[Third Party Core] Load Contact Details Failure',
  props<{ error: IError }>()
);

export const updateLOAStatus = createAction(
  '[Third Party Core] Update LOA Status',
  props<{ data: IThirdPartyUpdateStatus }>()
);

export const updateLOAStatusSuccess = createAction(
  '[Third Party Core] Update LOA Status Success',
  props<{ data: IThirdPartyLOA }>()
);

export const updateLOAStatusFailure = createAction(
  '[Third Party Core] Update LOA Status Failure',
  props<{ error: IError }>()
);

export const loadTemplate = createAction(
  '[Third Party Core] Load Template'
);

export const loadTemplateSuccess = createAction(
  '[Third Party Core] Load Template Success',
  props<{ data: IThirdPartyTemplate }>()
);

export const loadTemplateFailure = createAction(
  '[Third Party Core] Load Template Failure',
  props<{ error: IError }>()
);

export const signLOA = createAction(
  '[Third Party Core] Sign LOA',
  props<{ data: IThirdPartyLOA }>()
);

export const signLOASuccess = createAction(
  '[Third Party Core] Sign LOA Success',
  props<{ data: IThirdPartyLOA }>()
);

export const signLOAFailure = createAction(
  '[Third Party Core] Sign LOA Failure',
  props<{ error: IError }>()
);

export const updateLOA = createAction(
  '[Third Party Core] Update LOA',
  props<{ data: { id: string; contract: IThirdPartyLOA } }>()
);

export const updateLOASuccess = createAction(
  '[Third Party Core] Update LOA Success',
  props<{ data: IThirdPartyLOA }>()
);

export const updateLOAFailure = createAction(
  '[Third Party Core] Update LOA Failure',
  props<{ error: IError }>()
);

export const hardReset = createAction(
  '[Third Party Core] hard Reset',
  props<{ data: boolean }>()
);
